<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M36.5 16a1.5 1.5 0 00-1.5 1.5V24a11 11 0 01-22 0v-6.5a1.5 1.5 0 00-3 0V24a14 14 0 0012.5 13.92V41H19a1.5 1.5 0 000 3h10a1.5 1.5 0 000-3h-3.5v-3.08A14 14 0 0038 24v-6.5a1.5 1.5 0 00-1.5-1.5z"/><path d="M24 32a8 8 0 008-8V12a8 8 0 00-16 0v12a8 8 0 008 8zm-5-20a5 5 0 0110 0v12a5 5 0 01-10 0z"/></svg>